<template>
    <div class="font-sans antialiased leading-tight p-0 xs:-mr-5 w-full overflow">
        <app-header></app-header>
        <div class="mb-6">
            <div class="bg-grey-lightest">
                <div class="container mx-auto px-6 pt-32">
                    <h1 class="text-center text-black font-semibold text-4xl mb-12">
                        Политика конфиденциальности
                    </h1>
                    <div class="pb-10">
                        <p class="mb-4">Настоящая Политика конфиденциальности описывает, как мы собираем, используем и защищаем личную информацию пользователей нашего мобильного приложения.</p>

                        <h2 class="mb-4">1. Сбор информации</h2>
                        <p>Мы можем собирать следующую информацию:</p>
                        <ul class="mb-4">
                            <li>Имя пользователя (если указывается);</li>
                            <li>Электронная почта (если предоставляется);</li>
                            <li>Идентификаторы устройства и данные журнала;</li>
                            <li>Информация об использовании приложения;</li>
                            <li>Обезличенные аналитические данные.</li>
                        </ul>

                        <h2 class="mb-4">2. Использование информации</h2>
                        <p>Собранная информация используется для:</p>
                        <ul class="mb-4">
                            <li>Поддержания и улучшения функциональности приложения;</li>
                            <li>Обратной связи с пользователями;</li>
                            <li>Анализа использования и ошибок приложения;</li>
                            <li>Соблюдения юридических обязательств.</li>
                        </ul>

                        <h2 class="mb-4">3. Конфиденциальность детей</h2>
                        <p>Мы уделяем особое внимание защите данных детей до 13 лет.</p>
                        <p>Наше приложение может использоваться детьми, однако:</p>
                        <ul class="mb-4">
                            <li>Мы не запрашиваем у детей личную информацию;</li>
                            <li>Мы не направляем рекламу, не ориентированную на детей;</li>
                            <li>Если вы — родитель или опекун и узнали, что ваш ребенок предоставил нам личные данные, пожалуйста, свяжитесь с нами, и мы немедленно удалим эту информацию.</li>
                        </ul>

                        <h2 class="mb-4">4. Хранение и безопасность данных</h2>
                        <p class="mb-4">Все данные хранятся в безопасной среде, и доступ к ним ограничен. Мы предпринимаем разумные меры для защиты данных от несанкционированного доступа и утечек.</p>

                        <h2 class="mb-4">5. Передача данных третьим лицам</h2>
                        <p class="mb-4">Мы не передаем личные данные третьим лицам, за исключением случаев, предусмотренных законом, или в рамках использования сервисов аналитики (например, Google Firebase), которые обрабатывают данные в соответствии со своими политиками.</p>

                        <h2 class="mb-4">6. Изменения политики</h2>
                        <p class="mb-4">Мы можем время от времени обновлять настоящую Политику. Об изменениях мы уведомим пользователей, разместив обновленную версию в Google Play Store или по соответствующему URL на сайте приложения.</p>

                        <h2 class="mb-4">7. Контактная информация</h2>
                        <p class="mb-4">Если у вас есть вопросы по поводу этой Политики, вы можете связаться с нами по адресу: <a href="mailto:lingua.ai.mobile.app@gmail.com">lingua.ai.mobile.app@gmail.com</a></p>
                    </div>
                </div>
            </div>
            <svg id="curveDownColor" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
                <path style="fill: #f8fafc;" d="M0 0 C 50 100 80 100 100 0 Z" />
            </svg>
        </div>
        <app-download></app-download>
        <app-footer></app-footer>
    </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import AppDownload from "./components/AppDownload.vue";

export default {
    components: {
        AppHeader,
        AppFooter,
        AppDownload
    }
};
</script>

<style>
@tailwind preflight;
@tailwind components;
@tailwind utilities;
</style>
